export const CLICK = 'click'
export const RESIZE = 'resize'
export const SCROLL = 'scroll'
export const KEYDOWN = 'keydown'
export const CHANGE = 'change'
export const INPUT = 'input'
export const SUBMIT = 'submit'
